

















import { Vue, Component, Prop } from "vue-property-decorator";
import list, {
  LearningGroupParams as ILearningGroupParams
} from "@/getinfo-api/learning-groups";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models";
import LearningGroupTable from "@/components/learning-group/LearningGroupTable.vue";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({ components: { LearningGroupTable } })
export default class LearningGroupTableByCourseId extends Vue {
  @Prop() courseId!: string;
  groups: ILearningGroup[] = [];
  isLoading: boolean = false;
  count: number = 0;
  pageNumber: number = 1;
  filter: ILearningGroupParams = {
    companyId: this.selectedCompany,
    limit: 30,
    offset: 0,
    courseId: this.courseId
  };

  get selectedCompany() {
    return getCurrentCompanyId();
  }
  getLearningGroups() {
    this.isLoading = true;
    list(this.filter)
      .then(res => {
        this.groups = res.data.items;
        this.count = res.data.count;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  changePage() {
    this.$nextTick(() => {
      if (this.filter && this.filter.limit) {
        this.filter.offset = this.filter.limit * (this.pageNumber - 1);
        this.getLearningGroups();
      }
    });
  }

  created() {
    this.getLearningGroups();
  }
}
